import api from "./api";

export const profileDataMap = (item) => ({
  id: item?._id ?? null,
  name: item?.name ?? null,
  entityName: item?.entity?.name ?? null,
  dateCreated: item?.create_date
    ? new Date(item.create_date).toLocaleString()
    : null,
  lastUpdate: item?.last_update
    ? new Date(item.last_update).toLocaleString()
    : null,
  status: item?.type === "P" ? "Primary" : "", // Updated status logic
  profStatus: item?.status ?? null,
});

export const profileService = {
  getUserProfiles: async (entityId) => {
    try {
      // console.log(`Calling get user profiles API for EntityId: ${entityId}`);

      const response = await api.get(
        `/mapi/profile/getProfileListByEntityId?EntityId=${entityId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching user details:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getProfileList: async (userId) => {
    try {
      // console.log(`Fetching profile list for UserId: ${userId}`);

      const response = await api.get(
        `/mapi/profile/getProfileListByEntityId?UserId=${userId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching profile list:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getProfiles: async () => {
    try {
      // console.log(`Calling get all profiles`);

      const response = await api.get(`/mapi/profile/getProfile`);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching all profile details:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  editProfile: async (profileData) => {
    try {
      console.log("Editing Profile:", profileData);

      const response = await api.post(`/mapi/profile/editProfile`, profileData);
      return response.data;
    } catch (error) {
      console.error(
        "Error updating profile:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default profileService;
